const _ = require("lodash");
const manufacturerKeyGenerator = name =>
  _.toString(name)
    .replace(/[^a-z0-9]/gi, "")
    .toUpperCase();
export default manufacturerKeyGenerator;
